import { createFileRoute } from '@tanstack/react-router'

import { Button } from '@/shared/ui'
import { AuthModes } from '@/features/auth/policy'
import { clientEnv } from '@/env.client'

export const Route = createFileRoute('/sem-evento')({
  staticData: {
    auth: {
      mode: AuthModes.PUBLIC,
      requiresDigitalProductId: false
    }
  },
  component: NoTenantPage
})

function NoTenantPage() {
  const webappUrl = clientEnv.NEXT_PUBLIC_EVNTTZ_WEBAPP_BASE_URL

  return (
    <main
      className="mx-auto max-w-md px-4 py-12 text-center"
      data-testid="no-tenant-page"
    >
      <h1 className="mb-2 text-2xl font-bold text-gray-900">
        Evento não encontrado
      </h1>
      <p className="mb-4 text-muted-foreground">
        Este endereço não está vinculado a um evento. Publique o domínio pela
        rotina de publicação do evento ou, em desenvolvimento, acesse pelo
        subdomínio do evento (ex.: <code>enej.localhost:3120</code>).
      </p>
      <div className="flex flex-col justify-center gap-2 sm:flex-row">
        {webappUrl ? (
          <Button href={webappUrl} variant="primary">
            Ir para a plataforma
          </Button>
        ) : null}
        <Button href="/" variant="secondary">
          Recarregar
        </Button>
      </div>
    </main>
  )
}
